import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import {
  Remove as RemoveIcon,
  Add as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import "./Cart.css";
import { useDispatch, useSelector } from "react-redux";
import {
  add_product_action,
  remove_product_action,
  remove_all_product_action,
} from "../../../redux/actions/cart";

const Cart = (props) => {
  const { location, data, stagedChange } = props;
  const {
    upc,
    url,
    item_code,
    name,
    display_unit_price,
    display_case_price,
    unit_in_cart,
    case_in_cart,
    units_per_case,
  } = data;

  const customerStore = useSelector((state) => state.customer);

  const dispatch = useDispatch();

  const add = () => {
    if (location.search.includes("stagedOrder=1")) {
      stagedChange(data, 1, 1, true);
    } else {
      dispatch(add_product_action(data, customerStore, true));
    }
  };

  const substract = () => {
    if (unit_in_cart > 0) {
      if (location.search.includes("stagedOrder=1")) {
        stagedChange(data, 2, 1, true);
      } else {
        dispatch(remove_product_action(data, customerStore, true));
      }
    }
  };

  const addCase = () => {
    if (location.search.includes("stagedOrder=1")) {
      stagedChange(data, 1, 1, false);
    } else {
      dispatch(add_product_action(data, customerStore, false));
    }
  };

  const substractCase = () => {
    if (case_in_cart > 0) {
      if (location.search.includes("stagedOrder=1")) {
        stagedChange(data, 2, 1, false);
      } else {
        dispatch(remove_product_action(data, customerStore, false));
      }
    }
  };

  const deleteItem = (upc) => {
    if (location.search.includes("stagedOrder=1")) {
      stagedChange(data, 4, 1, true);
    } else {
      dispatch(remove_all_product_action(upc, customerStore));
    }
  };

  return (
    <Card className="rootCard">
      <CardMedia
        component="img"
        className="imgCard"
        image={url}
        alt="Item image"
      />
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Grid container>
            <Grid item xs={12} className="gridCloseButton">
              <IconButton
                className="closeIconButton"
                onClick={() => deleteItem(upc)}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={12}>
              <Typography component="div" variant="h6">
                {item_code ? item_code.item_code : ""}
              </Typography>
            </Grid>
            <Grid item xs={12} marginTop={"-10px"}>
              <Typography variant="subtitle1" component="div">
                {name}
              </Typography>
            </Grid>
            {display_unit_price > 0 ? (
              <>
                <Grid item xs={6} marginTop={"20px"} marginBottom={"-20px"}>
                  <Typography
                    variant="subtitle1"
                    component="div"
                    className="typographyPriceUnit"
                  >
                    ${display_unit_price}
                    <span style={{ fontWeight: 900 }}> UNIT</span>
                  </Typography>
                  {data.display_unit_price_per_lb ? (
                    <Typography
                      align="left"
                      className="typographyPricePerLbUnit"
                    >
                      Price per lb:
                      {data.display_unit_price_per_lb
                        ? " $" + data.display_unit_price_per_lb
                        : " N/A"}
                    </Typography>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  className="gridButtonsMath"
                  marginTop={"20px"}
                  marginBottom={"-20px"}
                >
                  <IconButton onClick={substract}>
                    {unit_in_cart > 1 ? (
                      <RemoveIcon color="error" />
                    ) : (
                      <DeleteIcon color="error" />
                    )}
                  </IconButton>
                  <Typography variant="h6" align="center">
                    {unit_in_cart}
                  </Typography>
                  <IconButton onClick={add}>
                    <AddIcon color="success" />
                  </IconButton>
                </Grid>
              </>
            ) : (
              <></>
            )}
            {display_case_price > 0 ? (
              <>
                <Grid item xs={6} marginTop={"20px"} marginBottom={"-20px"}>
                  <Typography
                    variant="subtitle1"
                    component="div"
                    className="typographyPriceCase"
                  >
                    ${display_case_price} ({units_per_case})
                    <span style={{ fontWeight: 900 }}> CASE</span>
                  </Typography>
                  {data.display_case_price_per_lb ? (
                    <Typography align="left" className="typographyPricePerLbCase">
                      Price per lb:
                      {data.display_case_price_per_lb
                        ? " $" + data.display_case_price_per_lb
                        : " N/A"}
                    </Typography>
                  ) : (
                    <></>
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  className="gridButtonsMath"
                  marginTop={"20px"}
                  marginBottom={"-20px"}
                >
                  <IconButton onClick={substractCase}>
                    {case_in_cart > 1 ? (
                      <RemoveIcon color="error" />
                    ) : (
                      <DeleteIcon color="error" />
                    )}
                  </IconButton>
                  <Typography variant="h6" align="center">
                    {case_in_cart}
                  </Typography>
                  <IconButton onClick={addCase}>
                    <AddIcon color="success" />
                  </IconButton>
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </CardContent>
      </Box>
    </Card>
  );
};

Cart.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Cart;
